module.exports = __webpack_public_path__ + "./img-lichin_522d6ce2e6d5fad0dde85e06ecf0ed01.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/img-lichin.png
// module id = 430
// module chunks = 0